import { ConstantsParser } from '../../../ConstantsParser'
import { StylesParser } from '../../../StylesParser'
export class Secondary {
  constructor() {
   this.name = 'Secondary'
   this.content = {
      text: 'Secondary',
      link: '#',
      event: null,
      eventData: null
    }
   this.view = this.viewHtml()
  }

  viewHtml() {
    let classes = (new ConstantsParser(this.classes())).parse().join(' ')
    let styles = (new StylesParser(this.styles())).parse()
    styles = Object.keys(styles).map(variationStyle => `${variationStyle}:${styles[variationStyle]}`).join(';')
    return `<div
      class="${classes}"
      style="${styles}"
    >Secondary</div>`
  }

  classes() {
    return [
      {property: 'Rounded', value: 'ROUNDED_LG'},
      {property: 'Size', value: 'SIZE_MD'},
      {property: 'FontWeight', value: 'BOLD'},
      {property: 'BorderStyle', value: 'BORDER_SOLID'},
      {property: 'BorderSideTopWidth', value: 'BORDER_TOP_NORMAL'},
      {property: 'BorderSideBottomWidth', value: 'BORDER_BOTTOM_NORMAL'},
      {property: 'BorderSideLeftWidth', value: 'BORDER_LEFT_NORMAL'},
      {property: 'BorderSideRightWidth', value: 'BORDER_RIGHT_NORMAL'},
     ]
  }

  phoneClasses() {
    return [
      {property: 'Rounded', value: 'ROUNDED_NONE'},
      {property: 'Size', value: 'SIZE_MD'},
      {property: 'FontWeight', value: 'BOLD'},
      {property: 'BorderStyle', value: 'BORDER_SOLID'},
      {property: 'BorderSideTopWidth', value: 'BORDER_TOP_NORMAL'},
      {property: 'BorderSideBottomWidth', value: 'BORDER_BOTTOM_NORMAL'},
      {property: 'BorderSideLeftWidth', value: 'BORDER_LEFT_NORMAL'},
      {property: 'BorderSideRightWidth', value: 'BORDER_RIGHT_NORMAL'},
     ]
  }

  tabletClasses() {
    return [
      {property: 'Rounded', value: 'ROUNDED_NONE'},
      {property: 'Size', value: 'SIZE_MD'},
      {property: 'FontWeight', value: 'BOLD'},
      {property: 'BorderStyle', value: 'BORDER_DASHED'},
      {property: 'BorderSideTopWidth', value: 'BORDER_TOP_NORMAL'},
      {property: 'BorderSideBottomWidth', value: 'BORDER_BOTTOM_NORMAL'},
      {property: 'BorderSideLeftWidth', value: 'BORDER_LEFT_NORMAL'},
      {property: 'BorderSideRightWidth', value: 'BORDER_RIGHT_NORMAL'},
     ]
  }

  styles() {
    return [
      {property:'TextColor', styleProperty: 'color', value: 'rgba(138.24,115.2,115.2, 1)'},
      {property:'BorderColor', styleProperty: 'border-color', value: 'rgba(138.24,115.2,115.2, 1)'}
    ]
  }

  buildData() {
    return {
      name: this.name,
      view: this.view,
    }
  }

  editorProperties() {
    return {
      content: this.content,
      styles: {
        phone : this.styles(),
        tablet : this.styles(),
        desktop : this.styles(),
      },
      classes: {
        phone : this.phoneClasses(),
        tablet : this.tabletClasses(),
        desktop : this.classes(),
      },
    }
  }
}
